import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowMonthPipe } from './show-month.pipe';
import { UtilitiesService } from '../../services/utilities.service';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ ShowMonthPipe ],
    exports: [ ShowMonthPipe ],
    providers: [ UtilitiesService ],
})
export class ShowMonthPipeModule {}
